import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'

export default function initMasonry() {
  const masonryGrid = document.querySelector('.masonry-grid')
  if (!masonryGrid) return

  const msnry = new Masonry(masonryGrid, {
    itemSelector: '.masonry-grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    gutter: 10,
    transitionDuration: 0,
  })

  // Layout once all images have loaded
  imagesLoaded(masonryGrid, () => msnry.layout())

  // Re-layout when <video> or <iframe> metadata loads
  const mediaElements = masonryGrid.querySelectorAll('video, iframe')
  if (mediaElements.length) {
    let layoutTimeout
    const relayout = () => {
      clearTimeout(layoutTimeout)
      layoutTimeout = setTimeout(() => msnry.layout(), 100)
    }

    mediaElements.forEach(el => {
      // If already loaded (metadata available), trigger layout immediately
      if ((el.tagName === 'VIDEO' && el.readyState >= 1) || (el.tagName === 'IFRAME' && el.complete)) {
        relayout()
      } else {
        // Videos: wait for metadata
        if (el.tagName === 'VIDEO') {
          el.addEventListener('loadedmetadata', relayout)
        }
        // Iframes: wait for load event
        if (el.tagName === 'IFRAME') {
          el.addEventListener('load', relayout)
        }
      }
    })
  }

  // Safety net: re-layout after short delay in case embeds load slowly
  setTimeout(() => msnry.layout(), 2000)
}
